import { useMemo } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table/custom-header';
import { PageTabRail } from '../../../../../../../../components/page-tab-rail/page-tab-rail';
import { type PortalTabbedNavigationTab, TabbedNavigationGroup } from '../../../../../../../../components/router/router-tabbed-navigation';
import { PortfolioAssetBalancesTable } from '../../../../../../../../features/portfolio/asset-balance/portfolio-asset-balances-table';
import { getPageHead } from '../../../../../../../../util/routing/meta';
import type { ViewContext } from '../../../../../../../../util/view-context';

export const Route = createFileRoute('/_app/_clearing-core/registration/account/$accountId/_account/_summary-list/asset')({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.RegistrationAccountSummaryList,
      label: 'Assets',
      order: 0,
    },
  } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.RegistrationAccountSummaryList>,
  head: () => getPageHead('Account Assets'),
  component: AccountAssetList,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  return (
    <PageTabRail
      actions={
        <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
          {filter}
        </HorizontalStack>
      }
      group={TabbedNavigationGroup.RegistrationAccountSummaryList}
    />
  );
}

function AccountAssetList() {
  const { accountId } = Route.useParams();
  const viewContext = useMemo(
    () =>
      ({
        kind: 'account',
        accountId,
      }) as const satisfies ViewContext,
    [accountId],
  );

  return (
    <PageLayout.Section noBorder>
      <PortfolioAssetBalancesTable HeaderActions={TableHeader} view={viewContext} />
    </PageLayout.Section>
  );
}
